'use client';
import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';

type MainProps = React.HTMLAttributes<HTMLElement> & {
  /** optional id for the main element, using withOptionalId helper */
  mainID?: string;
  className?: string;
};

const Main = ({ mainID, className = 'main', children, ...rest }: MainProps) => {
  return (
    <main {...withOptionalId(mainID)} className={className} {...rest}>
      {children}
    </main>
  );
};

export default Main;
